import cx from "classnames";
import { useState } from "react";

import { Icon } from "@/components/elements/Icon";
import { ShopCategoriesMenu } from "@/components/ShopCategoriesMenu";
import useBreakpointTest from "@/hooks/useBreakpointTest";

import header from "../header.module.css";

export const ShopSubmenu = ({ title }) => {
  const isDesktop = useBreakpointTest("lg");
  const [showSubMenu, setShowSubMenu] = useState<boolean>(isDesktop);

  const onShopClick = () => {
    if (!isDesktop) {
      setShowSubMenu(!showSubMenu);
    }
  };

  return (
    <>
      <button
        className={cx(header.shopTitle, { [header._isOpen]: showSubMenu })}
        onClick={onShopClick}
      >
        {title}
        <Icon
          type="chevron_down"
          className={header.chevronDown}
          size={isDesktop ? "sm" : "md"}
        />
      </button>
      <ShopCategoriesMenu
        className={cx(header.submenu, { [header._isOpen]: showSubMenu })}
      />
    </>
  );
};
